@if (!(['xs', 'sm', 'md'] | breakpoint | async)) {
  <mat-form-field appearance="fill" class="switcher-field">
    <mat-select required class="switcher" [(value)]="languageSwitcherService.selectedLanguage">
      <mat-select-trigger>
        <img src='../../../../../assets/flags/flag-{{languageSwitcherService.selectedLanguage.toLowerCase()}}.png' alt="image" class="flag">
        <span>{{languageSwitcherService.selectedLanguage}}</span>
      </mat-select-trigger>
      <mat-option value="EN" (click)="languageSwitcherService.changeLanguage($event)">
        <img src="../../../../../assets/flags/flag-en.png" alt="image" class="flag">
        <span>EN</span>
      </mat-option>
      <mat-option value="CZ" class="switcher" (click)="languageSwitcherService.changeLanguage($event)">
        <img src="../../../../../assets/flags/flag-cz.png" alt="image" class="flag">
        <span>CZ</span>
      </mat-option>
      <mat-option value="HU" class="switcher" (click)="languageSwitcherService.changeLanguage($event)">
        <img src="../../../../../assets/flags/flag-hu.png" alt="image" class="flag">
        <span>HU</span>
      </mat-option>
      <mat-option value="PL" class="switcher" (click)="languageSwitcherService.changeLanguage($event)">
        <img src="../../../../../assets/flags/flag-pl.png" alt="image" class="flag">
        <span>PL</span>
      </mat-option>
      <mat-option value="RO" class="switcher" (click)="languageSwitcherService.changeLanguage($event)">
        <img src="../../../../../assets/flags/flag-ro.png" alt="image" class="flag">
        <span>RO</span>
      </mat-option>
      <mat-option value="SK" class="switcher" (click)="languageSwitcherService.changeLanguage($event)">
        <img src="../../../../../assets/flags/flag-sk.png" alt="image" class="flag">
        <span>SK</span>
      </mat-option>
    </mat-select>
  <!--  <mat-label>-->
  <!--    <img src="'../../../../../assets/flags/flag-'{{languageSwitcherService.selectedLanguage.toLowerCase()}}'.png" alt="image" class="flag">-->
  <!--    <span>{{languageSwitcherService.selectedLanguage}}</span>-->
  <!--  </mat-label>-->
  </mat-form-field>
} @else {
  <mat-expansion-panel [class.mat-elevation-z0]="true">
    <mat-expansion-panel-header>
      <div class="list-item">
        <img src='../../../../../assets/flags/flag-{{languageSwitcherService.selectedLanguage.toLowerCase()}}.png' alt="image" class="flag">
        {{ languageSwitcherService.selectedLanguage }}
      </div>
    </mat-expansion-panel-header>
    <a mat-list-item (click)="languageSwitcherService.changeStringLanguage('EN')">
      <div class="list-item normal">
        <img src="../../../../../assets/flags/flag-en.png" alt="image" class="flag">
        EN
      </div>
    </a>
    <a mat-list-item (click)="languageSwitcherService.changeStringLanguage('CZ')">
      <div class="list-item normal">
        <img src="../../../../../assets/flags/flag-cz.png" alt="image" class="flag">
        CZ
      </div>
    </a>
    <a mat-list-item (click)="languageSwitcherService.changeStringLanguage('HU')">
      <div class="list-item normal">
        <img src="../../../../../assets/flags/flag-hu.png" alt="image" class="flag">
        HU
      </div>
    </a>
    <a mat-list-item (click)="languageSwitcherService.changeStringLanguage('PL')">
      <div class="list-item normal">
        <img src="../../../../../assets/flags/flag-pl.png" alt="image" class="flag">
        PL
      </div>
    </a>
    <a mat-list-item (click)="languageSwitcherService.changeStringLanguage('RO')">
      <div class="list-item normal">
        <img src="../../../../../assets/flags/flag-ro.png" alt="image" class="flag">
        RO
      </div>
    </a>
    <a mat-list-item (click)="languageSwitcherService.changeStringLanguage('SK')">
      <div class="list-item normal">
        <img src="../../../../../assets/flags/flag-sk.png" alt="image" class="flag">
        SK
      </div>
    </a>
  </mat-expansion-panel>
}
